import { useState, useEffect } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import DashboardMetrics from '../components/DashboardMetrics';
import ReviewsBreakdown from '../components/ReviewsBreakdown';
import CreateWidgetCard from '../components/CreateWidgetCard';
import { dashboardAPI } from '../services/api';
import usePageTitle from '../hooks/usePageTitle';

const Dashboard = () => {
    usePageTitle('Dashboard');
    const [dashboardData, setDashboardData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                setIsLoading(true);
                const response = await dashboardAPI.getDashboardMetrics();
                setDashboardData(response.data.data);
                setError(null);
            } catch (err) {
                setError('Failed to load dashboard data');
                console.error('Dashboard fetch error:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDashboardData();
    }, []);

    return (
        <DashboardLayout>
            <div className="space-y-8 bg-gray-50 min-h-screen">

                {error && (
                    <div className="bg-red-50 border border-red-200 rounded-2xl p-4">
                        <p className="text-red-600">{error}</p>
                    </div>
                )}

                {/* Metrics Cards */}
                <DashboardMetrics data={dashboardData} isLoading={isLoading} />

                {/* Content Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {/* Reviews Breakdown */}
                    <ReviewsBreakdown data={dashboardData} isLoading={isLoading} />

                    {/* Create Widget Card */}
                    <CreateWidgetCard />
                </div>

            </div>
        </DashboardLayout>
    );
};

export default Dashboard; 